import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Badge, Tooltip } from "@opensea/ui-kit";
import { ErrorFilled } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { useReceiptErrors } from "../../flow/hooks/useErrors";
import { useIsFlowActive } from "../../flow/hooks/useIsFlowActive";
import { ReceiptRowDisplay } from "../Receipt";
import { getItemQuoteResultError } from "./getItemQuoteResultError";
import { lookupPricingForItem } from "./helpers";
import { useQuoteReceiptProvider } from "./QuoteReceiptProvider";
import { QuoteReceiptRowFragment } from "./QuoteReceiptRow.fragment";
export const QuoteReceiptRow = t0 => {
  const $ = _c(20);
  const {
    item: quoteKey
  } = t0;
  const t = useTranslations("wallet.QuoteReceiptRow");
  const {
    initialPrices,
    hidePricing
  } = useQuoteReceiptProvider();
  const quote = readFragment(QuoteReceiptRowFragment, quoteKey);
  const QuoteReceiptErrors = useReceiptErrors();
  const isAcceptOfferFlow = useIsFlowActive("accept-offer");
  if (quote.__typename === "ItemNotFound") {
    return null;
  }
  const error = getItemQuoteResultError(quote)?.message || QuoteReceiptErrors?.[quote.item.id];
  if (quote.__typename === "ItemQuote") {
    const {
      item,
      pricePerItem
    } = quote;
    const initialPrice = lookupPricingForItem(item, initialPrices);
    const hasPricingChanged = initialPrice && !bn(initialPrice.unit).eq(pricePerItem.token.unit);
    const warning = !item.isFungible && hasPricingChanged ? t("priceChanged") : undefined;
    let t1;
    if ($[0] !== isAcceptOfferFlow || $[1] !== t || $[2] !== warning) {
      t1 = warning ? isAcceptOfferFlow ? t("bestOfferTooltip") : t("bestListingTooltip") : undefined;
      $[0] = isAcceptOfferFlow;
      $[1] = t;
      $[2] = warning;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    const warningTooltip = t1;
    const t2 = item.isFungible ? quote.quantity : undefined;
    const t3 = error ? <Tooltip align="start" content={t("quoteUnavailable")}><Badge icon={ErrorFilled} variant="error">{error}</Badge></Tooltip> : warning ? <Tooltip content={warningTooltip} disabled={!warningTooltip}><Badge icon={ErrorFilled} variant="warning">{warning}</Badge></Tooltip> : item.collection ? <CollectionLockup collection={item.collection}><CollectionLockupContent><CollectionLockupTitle /></CollectionLockupContent></CollectionLockup> : null;
    const t4 = quote.marketplace?.identifier;
    let t5;
    if ($[4] !== item || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
      t5 = {
        imageUrl: item.imageUrl,
        title: item.name,
        quantity: t2,
        description: t3,
        marketplace: t4
      };
      $[4] = item;
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    const t6 = hidePricing ? undefined : {
      unit: pricePerItem.token.unit,
      symbol: pricePerItem.token.symbol,
      usd: pricePerItem.usd
    };
    let t7;
    if ($[9] !== quote || $[10] !== t5 || $[11] !== t6) {
      t7 = <ReceiptRowDisplay item={t5} price={t6} quantity={quote.quantity} />;
      $[9] = quote;
      $[10] = t5;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t1;
  if ($[13] !== error || $[14] !== t) {
    t1 = error ? <Tooltip align="start" content={t("quoteUnavailable")}><Badge icon={ErrorFilled} variant="error">{error}</Badge></Tooltip> : null;
    $[13] = error;
    $[14] = t;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== quote.item.imageUrl || $[17] !== quote.item.name || $[18] !== t1) {
    t2 = <ReceiptRowDisplay item={{
      imageUrl: quote.item.imageUrl,
      title: quote.item.name,
      description: t1
    }} price={undefined} quantity={0} />;
    $[16] = quote.item.imageUrl;
    $[17] = quote.item.name;
    $[18] = t1;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  return t2;
};